var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5664,
    cy: 18.6914,
    r: 18,
    fill: "#F9F5EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1211 12.293C13.1211 11.8788 13.4569 11.543 13.8711 11.543H23.2629C23.6771 11.543 24.0129 11.8788 24.0129 12.293V23.7617C24.0129 24.0354 23.8639 24.2873 23.6241 24.419C23.3842 24.5508 23.0917 24.5415 22.8607 24.3947L18.567 21.6666L14.2733 24.3947C14.0423 24.5415 13.7498 24.5508 13.51 24.419C13.2701 24.2873 13.1211 24.0354 13.1211 23.7617V12.293ZM14.6211 13.043V22.3966L18.1648 20.145C18.4103 19.989 18.7238 19.989 18.9692 20.145L22.5129 22.3966V13.043H14.6211Z",
    fill: "#164A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBookmark);
export default __webpack_public_path__ + "static/media/Button-Bookmark.d98731e0b460dac5d7ba444069cf1826.svg";
export { ForwardRef as ReactComponent };